function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo, useState } from 'react';
import claimProjectReportsListsService from '../services/lists/claim_groups/claim_project_reports_lists.service';
import ClaimProjectReportsList from '@components/admin/claimProjectReports/ClaimProjectReportsList';
import { buildQueryString } from '../services/service';
import Pagination from '../util/Pagination';
import { Loading } from '../util';
import { PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR, PROJECT_OVERVIEW_TABLE, PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON, PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS } from '@rd-web-markets/market/dist/constants';
import { useTableColumnSelectorConfig } from '../util/Table/useTableColumnSelectorConfig';
const initialParams = {
  page: 1,
  order_by: 'report_order',
  group_projects: 'default',
  query: ''
};
const PROJECT_OVERVIEW_TABLE_NAME = 'project_overview_table';

/**
 * Currently this component renders the list of projects with headers as defined in the constant files for each market.
 * However in order to reuse the functionality for othe pages, that more or less render the same things, we now have the 
 * customHeaders and customColumns array properties.
 * @param {*} param0 
 * @returns 
 */
export default function ProjectsList(_ref) {
  let {
    claimGroup,
    setClaimGroup,
    additionalQueryParams = {},
    mandatoryParams = {},
    customHeaders = null,
    customColumns = null,
    accountType,
    handleToaster,
    groupProjects = 'default',
    renderExpandedRowContent = null,
    isTechnicalNarrativePage = false
  } = _ref;
  const [loading, setLoading] = useState(false);
  const columnParams = useMemo(() => ({
    claimGroup
  }), [claimGroup]);
  const tableColumnSelectorConfig = useTableColumnSelectorConfig({
    tableName: PROJECT_OVERVIEW_TABLE_NAME,
    emptyColumnSelectorJson: PROJECT_OVERVIEW_TABLE_EMPTY_COLUMN_SELECTOR_JSON,
    minimumRequiredColumns: PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS,
    tableConfig: PROJECT_OVERVIEW_TABLE,
    columnParams,
    enabled: PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR,
    setLoading
  });
  const selectedProjectOverviewTableConfig = tableColumnSelectorConfig.selectedTableConfig;
  const selectedProjectFields = useMemo(() => {
    if (!PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR) {
      return [];
    }
    if (!selectedProjectOverviewTableConfig) {
      return PROJECT_OVERVIEW_TABLE_MINIMUM_REQUIRED_COLUMNS;
    }
    return selectedProjectOverviewTableConfig.selectedBackendFields;
  }, [selectedProjectOverviewTableConfig]);
  const selectedProjectFieldsQuery = useMemo(() => selectedProjectFields.join(','), [selectedProjectFields]);
  const [reports, setReports, totalPages, setTotalPages, params, setParams, fetchAllProjetcs, totalCostSum, totalQeSum] = claimProjectReportsListsService.useFetchAll({
    accountType,
    claimGroupId: claimGroup.id,
    initialQueryParams: buildQueryString(_objectSpread(_objectSpread(_objectSpread({}, initialParams), additionalQueryParams), {}, {
      fields: selectedProjectFieldsQuery
    })),
    setLoading,
    groupProjects
  });
  useEffect(() => {
    if (!PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR) {
      return;
    }
    if (params.fields === selectedProjectFieldsQuery) {
      return;
    }
    setReports(null);
    setParams(currentParams => {
      if (currentParams.fields === selectedProjectFieldsQuery) {
        return currentParams;
      }
      return _objectSpread(_objectSpread({}, currentParams), {}, {
        fields: selectedProjectFieldsQuery
      });
    });
  }, [params.fields, selectedProjectFieldsQuery, setParams, setReports]);
  const handlePage = pageNumber => {
    window.scrollTo(0, 0);
    setParams(_objectSpread(_objectSpread({}, params), {}, {
      page: pageNumber
    }));
  };
  const tableColumnSelectorProps = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? {
    columnParams,
    columnSelectorConfig: tableColumnSelectorConfig
  } : null;
  const isProjectFieldsRequestPending = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR && params.fields !== selectedProjectFieldsQuery;
  const isProjectOverviewTableConfigLoading = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR && !selectedProjectOverviewTableConfig;
  if (!reports || isProjectFieldsRequestPending || isProjectOverviewTableConfigLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loading, null));
  }
  const passDownCustomHeaders = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? customHeaders || selectedProjectOverviewTableConfig.headers : customHeaders;
  const passDownCustomColumns = PROJECT_OVERVIEW_TABLE_USES_TABLE_COLUMN_SELECTOR ? customColumns || selectedProjectOverviewTableConfig.columns : customColumns;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimProjectReportsList, {
    isTechnicalNarrativePage: isTechnicalNarrativePage,
    handleToaster: handleToaster,
    claimGroup: claimGroup,
    getData: fetchAllProjetcs,
    setClaimGroup: setClaimGroup,
    reports: reports,
    setReports: setReports,
    params: params,
    setParams: setParams,
    groupProjects: groupProjects,
    customHeaders: passDownCustomHeaders,
    customColumns: passDownCustomColumns,
    renderExpandedRowContent: renderExpandedRowContent,
    totalCostSum: totalCostSum,
    totalQeSum: totalQeSum,
    tableColumnSelectorProps: tableColumnSelectorProps
  }), /*#__PURE__*/React.createElement(Pagination, {
    currentPage: Number(params.page),
    totalPages: totalPages,
    handlePageChange: handlePage
  }));
}